if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;
        const variantIdInput = this.form.querySelector('[name=id]');
        if (variantIdInput) variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (this.submitButton && document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // The size guide panel also contains a product-form, so only the main form (outside the panel) wires up
        // the open/close controls. Otherwise every instance binds the same buttons and the extra ones throw.
        this.container = document.querySelector('.product__size-guide');
        this.sizeGuide = document.querySelector('a.product__size-trigger');
        if (this.sizeGuide && this.container && !this.container.contains(this)) {
          const closeTriggers = document.querySelectorAll('.product__size-overlay, .product__size-close');
          closeTriggers.forEach((trigger) => {
            trigger.addEventListener('click', (e) => {
              e.preventDefault();
              this.triggerSizeGuide('close');
            });
          });

          this.sizeGuide.addEventListener('click', (e) => {
            e.preventDefault();
            this.triggerSizeGuide('open');
          });
        }
      }

      validateSelected() {

        let _options = document.querySelectorAll('variant-selects input[type="radio"]');
        if (_options.length == 0) {
          return true;
        }

        let _result = false;
        let _label = 'size';

        _options.forEach((option) => {

          if (option.name.includes('Size')) {
            _label = 'a size';
          } else if (option.name.includes('Colour')) {
            _label = 'a colour';
          } else {
            _label = 'an option';
          }

          if (option.checked == true) {
            _result = true;
          }

        });

        document.querySelectorAll('.product-form__buttons').forEach((buttons) => {

          if (_result == false) {

            buttons.insertAdjacentHTML("beforeBegin",
              `<div class='none-selected'>Please select ${_label}</div>`);


          } else {

            let _message = document.querySelectorAll('.none-selected');

            if (_message.length > 0) {
              _message.forEach((message) => message.remove());
            }

          }

        });

        return _result;

      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        let _canSubmit = this.validateSelected();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (_canSubmit == false) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.querySelector('.loading__spinner')) { this.querySelector('.loading__spinner').classList.remove('hidden'); }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      triggerSizeGuide(state) {
        if (!this.container) return;
        this.container.classList.toggle('active', state === 'open');
      }
    }
  );
}
